import { ICreditCard, ICreditCardInfo } from 'redhotpie-shared-lib/types/login';
import * as utils from '../functions/utils';

export interface IApiCreditCard {
  Number?: string;
  Month?: number;
  Year?: number;
  CCV?: string;
}

export class CreditCard {
  number: string;
  month: number;
  year: number;
  ccv: string;

  constructor() {
    this.number = '';
    this.month = -1;
    this.year = -1;
    this.ccv = '';
  }

  static mappingObjects(_obj: IApiCreditCard): ICreditCard {
    let obj = new CreditCard();
    obj.number = _obj.Number || '';
    obj.month = _obj.Month || -1;
    obj.year = _obj.Year || -1;
    obj.ccv = _obj.CCV || '';

    // Original logic used Object.assign which pulls in extra props, then cleaned them.
    // Since we map explicitly, this is less critical but preserved for consistency with legacy behavior.
    obj = (utils as any).cleanObjectKeys(Object.keys(new CreditCard()), obj);

    return obj;
  }
}

export interface IApiCreditCardInfo {
  CreditCard?: IApiCreditCard;
  UpdateToken?: string;
  ProductToken?: string;
}

export interface IApiCreditCardUpdate {
  PurchaseToken?: string;
  Product?: {
    Token?: string;
  };
  Card?: IApiCreditCard;
}

export default class CreditCardInfo {
  creditCard?: CreditCard;
  updateToken: string;
  productToken: string;

  constructor() {
    this.creditCard = undefined;
    // Uncommenting these as they are used in mappingObjectAfterUpdate
    this.updateToken = '';
    this.productToken = '';
  }

  static mappingObjects(_obj: IApiCreditCardInfo): ICreditCardInfo {
    let obj = new CreditCardInfo();
    // These were commented out in original JS, preserving that (they default to empty string from constructor)
    // obj.updateToken = _obj.UpdateToken || '';
    // obj.productToken = _obj.ProductToken || '';

    obj.creditCard = (_obj.CreditCard && CreditCard.mappingObjects(_obj.CreditCard)) || undefined;

    obj = (utils as any).cleanObjectKeys(Object.keys(new CreditCardInfo()), obj);

    return obj;
  }

  static mappingObjectAfterUpdate(_obj: IApiCreditCardUpdate): ICreditCardInfo {
    let obj = new CreditCardInfo();
    obj.updateToken = _obj.PurchaseToken || '';
    obj.productToken = (_obj.Product && _obj.Product.Token) || '';
    obj.creditCard = (_obj.Card && CreditCard.mappingObjects(_obj.Card)) || undefined;

    obj = (utils as any).cleanObjectKeys(Object.keys(new CreditCardInfo()), obj);

    return obj;
  }
}
